import { AbstractControl, ValidationErrors } from '@angular/forms';

export const PATTERN = /^\D/;
export const VALIDATOR_NAME = 'noLeadingDigit';
export const TRANSLATION_KEY = 'label.validation.noLeadingDigit';

export function noLeadingDigitValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && typeof control.value === 'string' && !new RegExp(PATTERN).test(control.value)) {
    return { [VALIDATOR_NAME]: true };
  }

  return null;
}
